import { api } from "./client";

export const analysisApi = {
  startScan: (payload) => api.post(`/codebase/analysis/scans`, payload),

  getScan: (scanId) => api.get(`/codebase/analysis/scans/${scanId}`),

  getScanResults: (scanId, params) =>
    api.get(`/codebase/analysis/scans/${scanId}/results`, { params }),

  getRepoHealth: (repoId) =>
    api.get(`/codebase/analysis/repos/${repoId}/health`),

  getRepoTrends: (repoId, limit = 25) =>
    api.get(`/codebase/analysis/repos/${repoId}/trends`, { params: { limit } }),

  getDiagram: (repoId) => api.get(`/codebase/diagrams/${repoId}`),

  getModernization: (repoId) => api.get(`/codebase/modernization/${repoId}`),

  getSonarBundle: (repoId, sonarToken) =>
    api.get(`/codebase/sonar/bundle/${repoId}`, {
      headers: sonarToken ? { "X-Sonar-Token": sonarToken } : undefined
    }),

  me: () => api.get(`/codebase/auth/me`)
};
